import React, { Component } from 'react';
import "./textAndImage.css";
import { Link } from "react-router-dom";

export default class extends Component {
  constructor(props) {
      super(props);
      this.state = {
          componentReady: 'ready'
      };
  }

  render() {
    var ratioImage = "/images/square.png"
    if(this.props.ratio != "square"){
      ratioImage = "/images/rectangle.png"
    }
    var direction = "right";
    if(this.props.direction === "left"){
      direction = "left";
    }
    var resizeMode = "cover";
    if(this.props.resizeMode === "contain"){
      resizeMode = "contain";
    }
    return (
      <div className={'text-and-image-container'}>
        <div className={`row ${ this.props.direction }`}>
          <div className="small-12 medium-6">
            <img className="full-width" src={ratioImage} style={{backgroundImage: `url(${ this.props.image })`,backgroundSize:resizeMode,backgroundPosition:'center',backgroundRepeat:'no-repeat'}} />
          </div>
          <div className="small-12 medium-6 row text-and-image-padding">
            <div className="full-width" style={{margin:"auto"}}>
              {this.props.title && <h4>{this.props.title}</h4>}
              {this.props.description && <p className="subheading" style={{"marginTop":"20px"}}>{this.props.description}</p>}
              <div style={{"marginTop":"20px"}}>
                {this.props.content && this.props.content}
              </div>
              {this.props.buttonLink && <Link className="button" to={this.props.buttonLink} style={{"marginTop":"20px"}}>{this.props.buttonText}</Link>}
              {this.props.hrefLink && <a className="button" target="_blank" href={this.props.hrefLink} style={{"marginTop":"20px"}}>{this.props.buttonText}</a>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/textAndImage/index.js